// Modal - Messages / Loading
const modalErrorMessage = document.querySelector('#messages-modal')
const modalLoading = document.querySelector('#loading-modal')
const modalMessage = document.querySelector('#messages-modal .description')
const modalTitle = document.querySelector('#messages-modal .title')
import '../nice_select.js'

export function modalMessages(message, title) {
    modalMessage.innerHTML = message
    modalTitle.innerHTML = title
    modalErrorMessage.classList.add('open-modal')
}
export function loadingModal(action) {
    if (action === 'add') {
        modalLoading.style.display = 'flex'
    } else {
        modalLoading.style.display = 'none'
    }
}
export default function API_MAPS_SERVICES(allAddress, idMap, idForms, pathMarkerSVG, type, messageRefence, messageNotFound, mainDivId) {
    /*
        SUMMARY
            0 - Const / variables

            1 - Functions
                // Create Markers
                // Verify if contains nearby Services
                // Map / Attributes
                // User Coords
                // Calc Coords
                // Zoom in a Service
                // Modal - Messages / Loading
                // Insert Cards in Html

            2 - Actions

    */

    /*---------------------/  0 - Const / variables /----------------------*/
    // messages
    let platform = new H.service.Platform({
        'apikey': 'PVjG2C87NWztpCHBTpVmR7MP2Cfka35bfohUx7igBnY'
            // 'apikey': 'QEYPoO3xSNcfZayZbpLwO9JjJU5_id9rgrmM7QogASw'
    });

    let isMobile = window.screen.width < 999

    let clusteringLayer
    let objectLayerCircle
    let objectProviderCircle

    let geocoder;
    let map;

    let widthMarker = isMobile ? 30 : 53
    let heightMarker = isMobile ? 43 : 76
    let markerService = pathMarkerSVG
    let markerUser = document.getElementById('pin-markerUser').dataset.image

    let ray = 100
    let ui;
    let hasNearbyServices = false
    let allCoords = allAddress
    let nearbyServices = []
    let userCoords = undefined

    let nearbyServicesPerView = []
    let amountToShow = 50
    let saveUserCoords

    var clusterSvgTemplate = `<svg id="er4mKozcWDB1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 53.144 75.735" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g transform="translate(-2685.73-1771.34)"><path d="M2711.66,1771.342c13.811,0,24.937,9.565,26.932,22.639.632691,5.018099.010081,10.114776-1.812,14.833-2.497005,6.775308-5.807215,13.222461-9.858,19.2-4.281907,6.545842-9.006604,12.791088-14.141,18.692-.308.356-.474.581-.91.072-7.705181-8.732827-14.395563-18.310979-19.943-28.551-2.597188-4.752243-4.505614-9.849571-5.668-15.139-2.845941-14.243534,6.279651-28.130847,20.483-31.171c1.614677-.361354,3.262515-.554054,4.917-.575Z" fill="#e74e00"/></g><ellipse rx="19.537263" ry="19.537263" transform="translate(26.572 27.682849)" fill="#fff" stroke-width="0"/><text dx="0" dy="0" font-family="'Avenir', Arial, Helvetica, sans-serif" font-size="25px" font-weight="700" style='transform: {positionTransform};' fill="#e74e00" stroke-width="0"><tspan y="0" font-weight="700" stroke-width="0">{weight}</tspan></text></svg>`

    var CUSTOM_CLUSTER = {
        getClusterPresentation: function (cluster) {
            let positionTransform
            let fontSize
            let weight = cluster.getWeight()

            if (Number(weight) < 10) {
                positionTransform = 'translate(20px, 36px)'
                fontSize = '25px'
            } else if (Number(weight) < 100) {
                positionTransform = 'translate(13px, 36px)'
                fontSize = '25px'
            } else {
                positionTransform = 'translate(12px, 34px)'
                fontSize = '18px'
            }

            let svgString = clusterSvgTemplate.replace(/\{weight\}/g, weight).replace(/\{positionTransform\}/g, positionTransform);

            let clusterIcon = new H.map.Icon(svgString, {
                size: { w: widthMarker, h: heightMarker },
                anchor: { x: 30, y: 30 }
            })

            let clusterMarker = new H.map.Marker(cluster.getPosition(), {
                icon: clusterIcon,
                min: cluster.getMinZoom(),
                max: cluster.getMaxZoom()
            });

            return clusterMarker;
        },
        getNoisePresentation: function (noisePoint) {
            var data = noisePoint.getData()

            let noiseMarker = new H.map.Marker(noisePoint.getPosition(), {
                min: noisePoint.getMinZoom(),
                icon: new H.map.Icon(markerService, {
                    size: { w: widthMarker, h: heightMarker },
                }),
            });

            const textInMarker = `
                ${data.title_fantasy ? `<p><b style='text-transform: uppercase;'> ${data.title_fantasy}</b> </p>` : ''} \n
                ${data.address ? `<p> ${data.address} </p>` : ''} \n
                ${data.phone ? `<p> ${data.phone} </p>` : ''} \n
                ${data.email ? `<p> ${data.email} </p>` : ''} \n
                ${data.link ? `<a style='text-decoration: none' target='_blank' href='${data.link}'> ${data.link} </p>` : ''} \n
            `
            noiseMarker.setData(textInMarker);

            return noiseMarker;
        }
    };


    const defaultCoords = {
        lat: -29.149433066870035,
        lng: -51.51513704390874,
    }

    const btnStore = document.querySelectorAll(`.search--ginle--store#${type}`)
    let inputAddress
    if (isMobile) {
        inputAddress = document.querySelector(`${idForms}.mobile #address-form`)
    } else {
        inputAddress = document.querySelector(`${idForms} #address-form`)
    }
    const btnCloseErro = document.querySelectorAll("#messages-modal .close-info-message")

    /*---------------------- -------------------------*/
    $(document).ready(function () {
        $('#amount-services').niceSelect();
    });

    $(document).on("click", ".nice-select .option:not(.disabled)", function (t) {
        var s = $(this),
            n = s.closest(".nice-select");
        const value = s.data("value")
        amountToShow = value
        setServicesPerView(saveUserCoords)
    })

    /*---------------------/ 1 - Functions /----------------------*/

    function setSmoothScrollTo(endX, endY, duration) {
        const startX = window.scrollX || window.pageXOffset;
        const startY = window.scrollY || window.pageYOffset;
        const distanceX = endX - startX;
        const distanceY = endY - startY;
        const startTime = new Date().getTime();

        duration = typeof duration !== "undefined" ? duration : 400;

        const easeInOutQuart = (time, from, distance, duration) => {
            if ((time /= duration / 2) < 1)
                return (distance / 2) * time * time * time * time + from;
            return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
        };

        const timer = setInterval(() => {
            const time = new Date().getTime() - startTime;
            const newX = easeInOutQuart(time, startX, distanceX, duration);
            const newY = easeInOutQuart(time, startY, distanceY, duration);
            if (time >= duration) {
                clearInterval(timer);
            }
            window.scroll(newX, newY);
        }, 1000 / 60);
    }


    let onError = function (result) {
        modalMessages('Algum erro aconteceu ao solicitar a localização de uma de nossas unidades, estamos tentando resolve-lo...', 'Ops !')
        return;
    };
    function filterOneNearbyServices(search_userCoods) {
        nearbyServicesPerView = []
        clearMarkers()
        loadingModal('remove')
        createMarkerUser(search_userCoods.lat, search_userCoods.lng)
        // modalMessages(messageNotFound, 'Ops!')

        let distance = 10000000
        let nearby
        allCoords.forEach(service => {
            const km = calcDistanceBeetweenTwoPoints(search_userCoods, service)
            if (km < distance) {
                distance = km
                nearby = service
            }
        })

        nearbyServicesPerView.push(nearby)
        nearbyServices.push(nearby)
        startClustering()
        loadingNearbyServicesCards()
    }
    function setServicesPerView(coordUser) {
        saveUserCoords = coordUser
        nearbyServices.sort(function (a, b) {
            return a.distance - b.distance;
        });

        nearbyServicesPerView = nearbyServices.slice(0, amountToShow)

        clearMarkers();
        if (typeof(coordUser) == 'undefined') {
            coordUser = defaultCoords;
        }
        setMapCenter(coordUser.lat, coordUser.lng, 8);
        createMarkerUser(coordUser.lat, coordUser.lng, map);
        startClustering();
        loadingNearbyServicesCards();
    }


    // Create Markers
    function createMarkerServices(servicesInfo) {
        const nearbyServicesData = {
            id: servicesInfo.id,
            address: servicesInfo.address,
            title: servicesInfo.title,
            email: servicesInfo.email,
            phone: servicesInfo.phone,
            areas: servicesInfo.areas,
            link: servicesInfo.link,
            lat: servicesInfo.lat,
            lng: servicesInfo.lng,
            distance: servicesInfo.distance,
        }

        nearbyServices.push(nearbyServicesData)
        loadingModal('remove')
    }
    function createMarkerUser(lat, lng) {
        var provider = map.getBaseLayer().getProvider();
        objectProviderCircle = new H.map.provider.LocalObjectProvider();
        objectLayerCircle = new H.map.layer.ObjectLayer(objectProviderCircle);

        let circle = new H.map.Circle(
            { lat: lat, lng: lng },
            (ray * 1000),
            {
                style: {
                    strokeColor: 'rgba(231, 78, 0, 0.9)', // Color of the perimeter
                    lineWidth: 2,
                    fillColor: 'rgba(231, 78, 0, 0.1)',  // Color of the circle
                    zIndex: 0,
                }
            }
        );

        objectProviderCircle.getRootGroup().addObject(circle)
        map.addLayer(objectLayerCircle);


        let group = new H.map.Group({ zIndex: 0 });
        let coords = { lat: lat, lng: lng };
        let icon = new H.map.Icon(markerUser, {
            size: {
                w: 63,
                h: 63
            }
        });
        let marker = new H.map.Marker(coords, { icon: icon });

        group.addObject(marker);
        map.addObject(group);
    }

    // Verify if contains nearby Services
    function verifyNearbyServices(userCoords = false) {
        loadingModal('add')
        hasNearbyServices = false
        nearbyServices = []



        allCoords.forEach(address => {
            const coords = {
                lat: address.lat,
                lng: address.lng
            }

            const km = calcDistanceBeetweenTwoPoints(userCoords, coords);
            if (Number(km) < ray) {
                createMarkerServices({ ...address, distance: km })
                hasNearbyServices = true
            }

        });


        if (hasNearbyServices) {
            loadingNearbyServicesCards()
        }
        return hasNearbyServices
    }
    // Map / Attributes
    function clearMarkers() {
        map.removeLayer(objectLayerCircle);
        map.removeLayer(clusteringLayer);
        map.removeObjects(map.getObjects());
    }
    function setMapCenter(lat, lng, zoom) {
        map.setCenter({ lat, lng });
        map.setZoom(zoom);
    }
    function addOverlayToMap(map) {
        let img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = '../site/img/whereToFind/overlayer.png';
        let overlay = new H.map.Overlay(
            new H.geo.Rect(
                77.0056893, 144.1236369,
                -77.0056893, -144.1236369
            ),
            img,
            {
                volatility: true
            }
        );
        overlay.setBitmap(img);
        map.addObject(overlay);
    }
    function onMarkerClick(e) {
        var position = e.target.getGeometry(),
            data = e.target.getData(),
            bubble = onMarkerClick.bubble;

        if (data != undefined) {
            bubble = new H.ui.InfoBubble(position, {
                content: data
            });
            ui.addBubble(bubble);
            onMarkerClick.bubble = bubble;
            map.setCenter(position, true);
        }

    }
    function startClustering() {

        var dataPoints = []

        nearbyServicesPerView.forEach(function (item) {
            if (item.lat != undefined && item.lng != undefined) {
                let newDataPoint = new H.clustering.DataPoint(item.lat, item.lng, null, item)
                dataPoints.push(newDataPoint)
            }
        });

        var clusteredDataProvider = new H.clustering.Provider(dataPoints, {
            clusteringOptions: {
                eps: 32,
                minWeight: 2,
            },
            theme: CUSTOM_CLUSTER
        });

        clusteredDataProvider.addEventListener('tap', onMarkerClick);

        clusteringLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);

        map.getLayers().add(clusteringLayer);
    }
    async function initMap(lat = defaultCoords.lat, lng = defaultCoords.lng, isUserOrAdress = false, isSearchStore = false, zoom = 5) {

        let targetElement = document.getElementById(idMap);
        let defaultLayers = platform.createDefaultLayers();

        map = new H.Map(
            document.getElementById(idMap),
            defaultLayers.vector.normal.map,
            // defaultLayers.raster.satellite.map,
            {
                zoom: zoom,
                center: { lat: lat, lng: lng },
                pixelRatio: window.devicePixelRatio || 1
            });

        let mapEvents = new H.mapevents.MapEvents(map);
        map.addEventListener('mouse', function (evt) {

        });

        let behavior = new H.mapevents.Behavior(mapEvents);
        ui = H.ui.UI.createDefault(map, defaultLayers);

        window.addEventListener('resize', () => map.getViewPort().resize());
        addOverlayToMap(map);

        if (allCoords.length == 0) {
            clearMarkers()
            loadingModal('remove')
            modalMessages(`Não há ${messageRefence} cadastrados em nosso sitemas, tente novamente mais tarde`, 'Ops !')
            return;
        }

        if (isUserOrAdress) {
            const userLatLng = {
                lat: lat,
                lng: lng
            }

            const result = verifyNearbyServices(userLatLng)

            if (result) {
                loadingModal('remove')
                setServicesPerView(userCoords)
            } else {
                filterOneNearbyServices(userCoords)
            }

            return;

        } else {
            const userLatLng = {
                lat: defaultCoords.lat,
                lng: defaultCoords.lng
            }

            const result = verifyNearbyServices(userLatLng)

            if (result) {
                loadingModal('remove')
                setServicesPerView(userCoords)
            } else {
                filterOneNearbyServices(userCoords)
            }

            return;
        }

    }

    //  User Coords
    function setCoordsUSER_COMPANY(pos) {
        loadingModal('add');
        try {
            userCoords = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            };
            saveUserCoords = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
            }
        } catch (error) {

        }

        if (userCoords != undefined) {
            initMap(pos.coords.latitude, pos.coords.longitude, true)
        } else {
            initMap()
        }

    }
    function callGeoLocation() {
        loadingModal('add')
        navigator.geolocation.getCurrentPosition(setCoordsUSER_COMPANY, setCoordsUSER_COMPANY)
    }

    // Calc Coords
    function findCoords(address) {
        let addressNumbers = address.replace(/[^\d]/g, "");
        let addressClean = address.replace(/[\s]/g, "");
        if (addressClean.length < 10 && addressNumbers.length == 8) {
            address = addressNumbers;
            const parte1 = address.slice(0,5);
            const parte2 = address.slice(5,8);
            address = parte1 + '-' + parte2 + ' BR';
        }
        return new Promise((resolve, reject) => {
            let geocodingParams = {
                searchText: address,
                q: address,
            };

            let onResult = function (result) {
                try {
                    let locations = result.items[0].position
                    const position = {
                        lat: locations.lat,
                        lng: locations.lng
                    };

                    resolve(position);
                    return position;

                } catch (error) {
                    // modalMessages('Algum erro aconteceu ao solicitar a localização de uma de nossas unidades, estamos tentando resolve-lo...', 'Ops !')
                    resolve(undefined);
                    return undefined
                }
            };

            geocoder = platform.getSearchService();

            geocoder.geocode(geocodingParams, onResult, function (e) {
                reject(() => {
                    onError
                });
            });
        });
    }
    function toRadians(graus) {
        return (graus * Math.PI) / 180;
    }
    function calcDistanceBeetweenTwoPoints(firstLocale, secondLocale) {
        // Converter graus para radianos
        const startLat = toRadians(firstLocale.lat);
        const startLng = toRadians(firstLocale.lng);
        const endLat = toRadians(secondLocale.lat);
        const endLng = toRadians(secondLocale.lng);

        const earthRay = 6371.0 * 1000; // Em metros

        const differenceLat = endLat - startLat;
        const differenceLng = endLng - startLng;

        // Haversine equation
        const a =
            Math.sin(differenceLat / 2) ** 2 +
            Math.cos(startLat) * Math.cos(endLat) * Math.sin(differenceLng / 2) ** 2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        // distance in km
        const distance = (earthRay * c) / 1000;
        return distance;
    }

    // Zoom in a Service
    function zoomInOneService(id) {
        if(isMobile) setSmoothScrollTo(0,0, 300)
        allCoords.forEach((service) => {
            if (service.id == id) {
                setMapCenter(service.lat, service.lng, 17);
            }
        })

    }
    // Insert Cards in Html
    function loadingNearbyServicesCards() {
        nearbyServices.sort((a, b) => {
            return a.distance - b.distance;
        });
        let dataForm = 'cardData=' + JSON.stringify(nearbyServices);
        // '&' causa um comportamento inesperado ao enviar os dados
        dataForm = dataForm.replace(/&/g, "EEE");
        $.ajax({
            type: "post",
            url: $(mainDivId).attr('filterRoute'),
            data: dataForm,
            dataType: "html",
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (html) {
                $(mainDivId).find(`div.content--results#result--${type}`).children().remove();
                $(mainDivId).find(`div.content--results#result--${type}`).append(html);
                const btnStore = document.querySelectorAll(`.search--ginle--services.${type}`)
                btnStore.forEach(service => {
                    service.addEventListener("click", () => {
                        const address = service.getAttribute("servicesId")
                        zoomInOneService(address)
                    });
                })
            }
        });
    }

    /*--------------------/ 2 - Actions /---------------------------*/
    $(document).ready(function () {
        callGeoLocation()
    });

    btnStore.forEach(store => {
        store.addEventListener("click", () => {
            const address = store.querySelector('.address').innerHTML
            zoomInOneService(address)
        })
    })

    btnCloseErro.forEach(btn => {
        btn.addEventListener("click", () => {
            modalErrorMessage.classList.remove('open-modal')
        })
    })

    $(document).on('submit', idForms, function (e) {
        loadingModal('loading')
        e.preventDefault();
        const address = inputAddress.value

        // Validation
        if (address == '') {
            modalMessages('Por favor, informe uma localização!', 'Ops')
            return 0
        }

        const promise = async () => {
            loadingModal('add')
            return findCoords(address).then(coordUser => {
                clearMarkers()
                verifyNearbyServices(coordUser)
                if (hasNearbyServices) {
                    setServicesPerView(coordUser)
                } else {
                    loadingModal('remove')
                    filterOneNearbyServices(coordUser)
                }
                return;
            })
                .catch(error => {
                    console.log(error)
                    loadingModal('remove')
                    modalMessages('Algum erro ocorreu em sua solicitação, por favor tente novamente', 'Ops!')
                    clearMarkers()
                });
        }

        promise()
    });
}
